<form name="form{{in}}" #f="ngForm" *ngIf="service" class="bg-light border mb-3">
  <div class="d-flex align-items-center">
    <div class="form-row min-form pad15">

      <div class="col-3 af-form-group">
        <label translate>lblMake</label>
        <div class='lbl-info'>
          <ng-select name="brandName{{in}}" id="Add-Brand{{in}}"
            placeholder="{{ 'lblSelectMake' | translate }}" required [(ngModel)]="serviceFilter.BrandId"  (change)="onMakeSelected($event, true)"
            [ngModelOptions]="{standalone: true}" [disabled]="isAddView">
            <ng-template ng-header-tmp>
              <span class="mbold w-66px">Code</span>
              <span class="mbold" translate>lblMake</span>
            </ng-template>

            <ng-option *ngFor="let type of service.makeList" [value]="type.id">
              <span class="w-66px">{{type.brandCode}}</span>
              <span class="mx-2 hide-ng-dropdown-panel">-</span>
              <span>{{type.brandName}}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-3 af-form-group">
        <label translate>lblModel </label>
        <div class='lbl-info'>
          <ng-select name="brandName{{in}}" id="Add-Brand{{in}}"
            placeholder="{{ 'lblSelectModel' | translate }}" required [(ngModel)]="serviceFilter.Model"
            [disabled]="isAddView">
            <ng-option *ngFor="let type of service.modelList" [value]="type.modelNo">
              {{type.description}}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-3 af-form-group">
        <label translate>lblVehicleType </label>
        <div class='lbl-info'>
          <ng-select placeholder="{{ 'lblSelectVehical' | translate }}" name="vehicleType{{in}}"
            id="Add-VehicleType{{in}}" [(ngModel)]="serviceFilter.VehicleTypeId" [ngModelOptions]="{standalone: true}"
            [disabled]="isAddView">
            <ng-template ng-header-tmp dropup>
              <span class="mbold w-66px">Code</span>
              <span class="mbold" translate>lblVehicalType</span>
            </ng-template>

            <ng-option *ngFor="let item of service.vehicleTypes" [value]="item.id">
              <span class="w-66px">{{item.code}}</span>
              <span class="mx-2 hide-ng-dropdown-panel">-</span>
              <span>{{item.name}}</span>
            </ng-option>
          </ng-select>
        </div>
      </div>


      <div class="col-3 af-form-group">
        <label translate>lblFuelType</label>
        <div class='lbl-info'>
          <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="service.fuels"
            (ngModelChange)="onChangeService($event)" [(ngModel)]="serviceFilter.FuelTypeId" [disabled]="isAddView"
            [ngModelOptions]="{standalone: true}">

          </ng-multiselect-dropdown>
        </div>
      </div>

      <div class="col af-form-group two-wid">
        <label translate>lblVehicleAge(Month)</label>
        <div class='lbl-info form-row'>
          <div class="col-6">
            <ng-select [(ngModel)]="serviceFilter.RangeFunctionForVehicleAge" [disabled]="isAddView"
              [ngModelOptions]="{standalone: true}" appendTo="body">
              <ng-option *ngFor="let item of service.vehicleAge" [value]="item.id">
                {{item.displayName}}
              </ng-option>
            </ng-select>
          </div>
          <div class="col-6">
            <input type="text" [(ngModel)]="serviceFilter.VehicleAge" maxlength="5" (keypress)="isDigit($event)"
              [disabled]="isAddView" [ngModelOptions]="{standalone: true}" class="form-control">
          </div>
        </div>
      </div>

      <div class="col af-form-group">
        <label translate>lblAND <span>/</span><span translate>lblOR</span></label>
        <div class='lbl-info'>
          <ng-select [(ngModel)]="serviceFilter.LogicFunction" [disabled]="isAddView" appendTo="body"
            [ngModelOptions]="{standalone: true}">
            <ng-option *ngFor="let item of service.logicOperator" [value]="item.id">
              {{item.displayName}}
            </ng-option>
          </ng-select>
        </div>
      </div>

      <div class="col af-form-group two-wid mb-0">
        <label translate>lblMileage(KM)</label>
        <div class='lbl-info form-row'>
          <div class="col-6">
            <ng-select [(ngModel)]="serviceFilter.RangeFunctionForMileage" [disabled]="isAddView" appendTo="body"
              [ngModelOptions]="{standalone: true}">
              <ng-option *ngFor="let item of service.mileage" [value]="item.id">
                {{item.displayName}}
              </ng-option>
            </ng-select>
          </div>
          <div class="col-6">
            <input type="text" maxlength="7" (keypress)="isDigit($event)" [disabled]="isAddView"
              [(ngModel)]="serviceFilter.Mileage" [ngModelOptions]="{standalone: true}" class="form-control">
          </div>
        </div>
      </div>

      <div class="col af-form-group mb-0">
        <label translate>lblDuration(min)<strong class="mlt6 required"> * </strong></label>
        <div class='lbl-info'>
          <input type="text" [(ngModel)]="serviceFilter.Duration" pattern="^[0-9]*$" maxlength="5" [disabled]="isAddView"
            required (keypress)="isDigit($event)" [ngModelOptions]="{standalone: true}" class="form-control">
        </div>
      </div>

      <div class="col af-form-group mb-0">
        <label translate>lblPrice<span class="text-sm1" translate>lblExclVat</span><strong class="mlt6 required"> * </strong></label>
        <div class='lbl-info'>
          <input type="text" [ngModel]="serviceFilter.Price | stringToNumber | number: '1.2-2'" maxlength="10" required
            [disabled]="isAddView" pattern="^[\d,.\s]+$" (blur)="onBlur($event)" [ngModelOptions]="{standalone: true}"
            class="form-control">
        </div>
      </div>

      <div class="col af-form-group mb-0">
        <label translate>lblPrice<span class="text-sm1" translate>lblInclVAT</span><strong class="mlt6 required"> * </strong></label>
        <div class='lbl-info'>
          <input type="text" [ngModel]="serviceFilter.PriceInclVAT | stringToNumber | number: '1.2-2'" maxlength="10" required [ngModelOptions]="{standalone: true}" disabled
            class="form-control">
        </div>
      </div>

      <div class="col af-form-group mt-4 mb-0">
        <div class="form-check mt-2">
          <input class="form-check-input" [(ngModel)]="serviceFilter.IsFixedPrice" [disabled]="isAddView"
            [ngModelOptions]="{standalone: true}"  (ngModelChange)="onChecked(obj, $event)" type="checkbox" value="" id="FixedPrice">
          <label class="form-check-label" for="FixedPrice" translate>
            lblFixedPrice
          </label>
        </div>
      </div>

      <div class="col af-form-group mt-4 mb-0">
        <div class="form-check mt-2">
          <input class="form-check-input" [(ngModel)]="serviceFilter.IsShowPrice" [disabled]="isAddView"
            [ngModelOptions]="{standalone: true}" type="checkbox" value="" id="ShowPrice">
          <label class="form-check-label" for="ShowPrice" translate>
            lblDisplayPriceInWidget
          </label>
        </div>
      </div>
      <div class="col af-form-group mb-0">
        <label for="discount"><span translate>lblDiscount </span></label>
        <div class="lbl-info">
          <input type="text" class="form-control customize-textbox text-right" [disabled]="isAddView"
          [ngModelOptions]="{standalone: true}"  id="discount"
          #discount="ngModel" 
          pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" 
          [(ngModel)]="serviceFilter.Discount" maxlength="6"
          (keypress)="checkDiscount($event)" />
            <div *ngIf="discount.errors?.pattern" class="help-block mt-1 text-danger" translate>
              lblDiscountBetween1to100
            </div>
        </div>
    </div>
    </div>
    <div class="mb-0 text-nowrap">

      <button type="button" class="btn btn-ico" (click)="RemoveServiceFilter(in)" *ngIf="!isRemoveView">
        <em class="fa fa-minus-circle font17 text-danger"></em>
      </button>
      <span class="ico-div" *ngIf="!isAddView"></span>
      <button type="submit" class="btn btn-ico ml-2" #addButton (click)="AddServiceFilter(in)" *ngIf="!isAddView">
        <em class="fa fa-plus-circle font17"></em>
      </button>

    </div>
  </div>


</form>